
    const data = {"name":"src/core/icons/align-horizontal-distribute","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M4 22H2V2h2v20M22 2h-2v20h2V2m-8.5 5h-3v10h3V7Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            